import GestaoPortfolios from '../../components/GestaoPortfolios'
import BannerOtimizeNegocio from '../../components/banner-otimize-negocio'
import BannerProjects from '../../components/bannerProjects'
import Diferenciais from '../../components/diferenciais'
import Rodape from '../../components/rodape'

export default function Pmo() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-pmo.png"
        title="/PMO AS"
        titleBold="A SERVICE"
        iconSrc="../assets/icone-projectiva-behub.png"
        iconAlt="Projectiva BeHub"
        iconText="be."
        iconTextBold="hub"
        descriptionBold="Todo grande projeto precisa de uma base sólida para alcançar resultados extraordinários."
        description="Com o PMO as a Service, você conta com uma estrutura dedicada e suporte especializado para garantir uma gestão de projetos mais ágil, eficiente e estratégica. É a escolha ideal para empresas que querem ir além, com controle, clareza e foco no que realmente importa: entregar valor."
        footerText="VERTICAL PROJECTS | Business Agility"
        buttonText="Quero me conectar"
        buttonColor="from-[#4B3BDB] to-[#A002CB]"
        brand="behub"
      />
      <GestaoPortfolios />
      <BannerOtimizeNegocio 
        headingBold="Aceleramos a sua jornada de transformação ágil, "
        headingText="impulsionando a evolução contínua."
        buttonText="Otimize seu negócio!"
        buttonUrl="/"
      />
      <Diferenciais 
        servicosData={[
          {
            icon: '../assets/icone-melhoria.png',
            iconHover: '../assets/icone-melhoria.png',
            title: 'Melhoria Contínua',
            text: (
              <>
                Avaliar a <strong>performance dos projetos</strong> após sua conclusão,
                elencar lições aprendidas e propor{' '}
                <strong>melhorias nos processos de gestão de projetos</strong>, para
                otimizar futuras iniciativas.
              </>
            ),
            glowColor: '#A800E4',
            url: '',
          },
          {
            icon: '../assets/icone-suporte.png',
            iconHover: '../assets/icone-suporte.png',
            title: 'Gestão de Qualidade',
            text: (
              <>
                Assegurar que os <strong>processos e entregáveis</strong> dos projetos
                atendam aos padrões de qualidade elevados e que agreguem resultados
                tangíveis.
              </>
            ),
            glowColor: '#A800E4',
            url: '',
          },
          {
            icon: '../assets/icone-risco.png',
            iconHover: '../assets/icone-risco.png',
            title: 'Gestão de Riscos',
            text: (
              <>
                Identificar, avaliar e gerenciar os riscos dos projetos, propondo
                soluções para mitigação de impactos negativos no andamento dos
                processos.
              </>
            ),
            glowColor: '#A800E4',
            url: '',
          },
          {
            icon: '../assets/gestao-icone.png',
            iconHover: '../assets/gestao-icone.png',
            title: 'Comunicação com Stakeholders',
            text: (
              <>
                <strong>Facilitar a comunicação</strong> entre os participantes do
                projeto (stakeholders), garantindo que todos os envolvidos estejam
                alinhados quanto aos <strong>objetivos, prazos e entregas</strong>.
              </>
            ),
            glowColor: '#A800E4',
            url: '',
          },
          {
            icon: '../assets/gestao-icone.png',
            iconHover: '../assets/gestao-icone.png',
            title: 'Gestão de Recursos',
            text: (
              <>
                <strong>Coordenar a alocação de recursos humanos e financeiros</strong>{' '}
                nos projetos, garantindo sua disponibilidade de forma eficiente e
                alinhada às necessidades de cada etapa.
              </>
            ),
            glowColor: '#A800E4',
            url: '',
          },
          {
            icon: '../assets/icone-suporte.png',
            iconHover: '../assets/icone-suporte.png',
            title: 'Suporte e Consultoria',
            text: (
              <>
                Disponibilizar suporte às equipes de projeto, por meio de{' '}
                <strong>treinamentos, consultoria técnica</strong> e auxílio no uso de
                ferramentas de gerenciamento.
              </>
            ),
            glowColor: '#A800E4',
            url: '',
          },
        ]}
        title="Diferenciais"
      />
      <Rodape />
    </>
  )
}
